module.exports = __webpack_public_path__ + "img/page-067.5495f1d6.jpg";